<template>
  <div>
    <v-toolbar dense flat>
      <v-layout align-center justify-space-between row fill-height>
        <v-flex xs12 sm5>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search owner / invoice number / invoice type / description"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3>
          <v-select
            v-model="search"
            hide-details
            :items="select"
            item-text="title"
            item-value="value"
            label="Select"
            style="padding: 0"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="loadingMessage"
      :items="filtermonitor"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ props.item.no }}
        </td>
        <td class="text-xs-center">
          {{ moment(props.item.date).format("YYYY/MM/DD") }}
        </td>
        <td class="text-xs-center">
          {{ moment(props.item.duedate).format("YYYY/MM/DD") }}
        </td>
        <td class="text-xs-center">
          {{ props.item.owner }}
        </td>
        <td class="text-xs-center">
          {{ props.item.invoice }}
        </td>
        <td class="text-xs-center">
          {{ props.item.type }}
        </td>
        <td class="text-xs-center">
          {{ props.item.discription }}
        </td>
        <td class="text-xs-center">
          {{ props.item.net }}
        </td>
        <td style="display: flex;justify-content: center;align-items: center;">
          <div
            :class="[
              props.item.status == 1
                ? 'badge_status--active'
                : props.item.status == 2
                ? 'badge_status--inactive'
                : props.item.status == 3
                ? 'badge_status--reject'
                : props.item.status == 4
                ? 'badge_status--delete'
                : null,
            ]"
          >
            {{
              props.item.status == 1
                ? "Pending"
                : props.item.status == 2
                ? "Approve"
                : props.item.status == 3
                ? "Reject"
                : props.item.status == 4
                ? "Delete"
                : props.item.status == 5
                ? "Edit document"
                : null
            }}
          </div>
        </td>
        <td class="text-xs-center">
          <v-btn
            icon
            @click="
              () => {
                dialog = true;
              }
            "
          >
            <v-icon small>remove_red_eye</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="
              () => {
                dialog = true;
              }
            "
          >
            <v-icon small>mdi-trash-can</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data"></template>
    </v-data-table>

    <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
      <v-icon color="red">close</v-icon>
      {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
      <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="650">
      <v-card style="border-radius: 13px;">
        <v-container
          ><v-card-title class="headline"
            >คุณต้องการลบข้อมูล Invoice<span style="color: #FDCA00;">
              #INV-0232111</span
            >
            นี้หรือไม่</v-card-title
          >
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click="dialog = false">
              CANCEL
            </v-btn>

            <v-btn color="green darken-1" flat="flat" @click="dialog = false">
              CONFIRM
            </v-btn>
            <v-spacer></v-spacer> </v-card-actions
        ></v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
export default {
  data: () => ({
    search: "",
    dialog: true,
    select_type: 0,
    loadingMessage: false,
    pagination: {
      rowsPerPage: 10,
    },
    select: [
      {
        title: "All status",
        value: "0",
      },
      {
        title: "Pending",
        value: "1",
      },
      {
        title: "Overdue",
        value: "2",
      },
      {
        title: "Complete",
        value: "3",
      },
    ],
    headers: [
      {
        text: "No.",
        value: "no",
        sortable: false,
        align: "center",
      },
      {
        text: "Create Date",
        value: "date",
        sortable: false,
        align: "center",
      },
      {
        text: "Due Date",
        sortable: false,
        value: "duedate",
        align: "center",
      },
      {
        text: "Owner",
        sortable: false,
        value: "owner",
        align: "center",
      },
      {
        text: "Invoice Number",
        value: "invoice",
        sortable: false,
        align: "center",
      },
      {
        text: "Invoice Type",
        value: "type",
        align: "center",
        sortable: false,
      },
      {
        text: "Description",
        value: "discription",
        align: "center",
        sortable: false,
        align: "center",
      },
      {
        text: "Net Price",
        value: "net",
        align: "center",
        sortable: false,
        align: "center",
      },
      {
        text: "Status",
        value: "status",
        align: "center",
        sortable: false,
        align: "center",
      },
      {
        text: "Action",
        value: "",
        align: "center",
        sortable: false,
        align: "center",
      },
    ],
    errSnackbar: false,
    snackBarMsg: null,
  }),
  watch: {
    //
  },
  computed: {
    ...mapState({
      monitor_list: (state) => state.Business.monitor_list,
    }),
    filtermonitor() {
      return this.monitor_list.filter(
        (val) =>
          val.owner.toLowerCase().includes(this.search.toLowerCase()) ||
          val.invoice.toLowerCase().includes(this.search.toLowerCase()) ||
          val.discription.toLowerCase().includes(this.search.toLowerCase()) ||
          (val.type.toLowerCase().includes(this.search.toLowerCase()) &&
            val.status.includes(this.select_type))
      );
    },
  },
  methods: {
    async getData() {
      this.loadingMessage = true;
      await this.$store.dispatch("Business/getMonitor_invoice");
      this.loadingMessage = false;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.badge_status--active {
  background-color: #fbd200;
  width: 80px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #ffffff;
  text-transform: uppercase;
}
.badge_status--inactive {
  background-color: #4caf50;
  width: 80px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #ffffff;
  text-transform: uppercase;
}
.badge_status--reject {
  background-color: #fb3200;
  width: 80px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #ffffff;
  text-transform: uppercase;
}
.badge_status--delete {
  background-color: #9b9a99;
  width: 80px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #ffffff;
  text-transform: uppercase;
}
</style>
